import common from './common';
import mga from './mga';
import sga from './sga';

const configs = { mga, sga };

export default { configs, common };
